/**
 * @generated SignedSource<<b5a41e9e680805b04b5cbe2dae0d094f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type MetricProgress = "DECREASING" | "INCREASING";
export type MetricType = "CURRENCY" | "NUMBER" | "PERCENTAGE";
export type ObjectiveStatus = "ABANDONED" | "AT_RISK" | "BEHIND" | "COMPLETED" | "NO_STATUS" | "ON_TRACK";
export type ObjectiveVisibility = "PRIVATE" | "PUBLIC";
import { FragmentRefs } from "relay-runtime";
export type ObjectiveQueryViewer$data = {
  readonly objectives: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly archived: boolean;
        readonly assigneeTeam: {
          readonly id: string;
          readonly title: string;
        } | null;
        readonly assigneeUser: {
          readonly email: string;
          readonly fullName: string;
          readonly id: string;
          readonly image: string;
          readonly isGuest: boolean;
        } | null;
        readonly children: ReadonlyArray<{
          readonly archived: boolean;
          readonly assigneeTeam: {
            readonly id: string;
            readonly title: string;
          } | null;
          readonly assigneeUser: {
            readonly email: string;
            readonly fullName: string;
            readonly id: string;
            readonly image: string;
            readonly isGuest: boolean;
          } | null;
          readonly contributors: ReadonlyArray<{
            readonly email: string;
            readonly fullName: string;
            readonly id: string;
            readonly image: string;
            readonly isGuest: boolean;
          }>;
          readonly contributorsTeams: ReadonlyArray<{
            readonly id: string;
            readonly title: string;
          }>;
          readonly cycle: {
            readonly id: string;
          } | null;
          readonly description: string | null;
          readonly dueDate: string | null;
          readonly hasAccess: boolean;
          readonly id: string;
          readonly keyResults: ReadonlyArray<{
            readonly assigneeTeam: {
              readonly id: string;
              readonly title: string;
            } | null;
            readonly assigneeUser: {
              readonly email: string;
              readonly fullName: string;
              readonly id: string;
              readonly image: string;
              readonly isGuest: boolean;
            } | null;
            readonly dueDate: string | null;
            readonly id: string;
            readonly metricCurrency: string | null;
            readonly metricCurrent: number;
            readonly metricProgress: MetricProgress;
            readonly metricStart: number;
            readonly metricTarget: number;
            readonly metricType: MetricType;
            readonly order: number;
            readonly progress: number;
            readonly title: string;
            readonly weight: number;
          }>;
          readonly parent: {
            readonly cycle: {
              readonly endDate: string | null;
              readonly startDate: string | null;
            } | null;
            readonly id: string;
            readonly level: number;
            readonly title: string;
          } | null;
          readonly progress: number;
          readonly status: ObjectiveStatus;
          readonly title: string;
          readonly visibility: ObjectiveVisibility;
          readonly weight: number;
        }> | null;
        readonly contributors: ReadonlyArray<{
          readonly email: string;
          readonly fullName: string;
          readonly id: string;
          readonly image: string;
          readonly isGuest: boolean;
        }>;
        readonly contributorsTeams: ReadonlyArray<{
          readonly id: string;
          readonly title: string;
        }>;
        readonly cycle: {
          readonly id: string;
        } | null;
        readonly description: string | null;
        readonly dueDate: string | null;
        readonly hasAccess: boolean;
        readonly id: string;
        readonly keyResults: ReadonlyArray<{
          readonly assigneeTeam: {
            readonly id: string;
            readonly title: string;
          } | null;
          readonly assigneeUser: {
            readonly email: string;
            readonly fullName: string;
            readonly id: string;
            readonly image: string;
            readonly isGuest: boolean;
          } | null;
          readonly dueDate: string | null;
          readonly id: string;
          readonly metricCurrency: string | null;
          readonly metricCurrent: number;
          readonly metricProgress: MetricProgress;
          readonly metricStart: number;
          readonly metricTarget: number;
          readonly metricType: MetricType;
          readonly order: number;
          readonly progress: number;
          readonly title: string;
          readonly weight: number;
        }>;
        readonly parent: {
          readonly cycle: {
            readonly endDate: string | null;
            readonly startDate: string | null;
          } | null;
          readonly id: string;
          readonly level: number;
          readonly title: string;
        } | null;
        readonly progress: number;
        readonly status: ObjectiveStatus;
        readonly title: string;
        readonly visibility: ObjectiveVisibility;
        readonly weight: number;
      };
    } | null>;
  } | null;
  readonly " $fragmentType": "ObjectiveQueryViewer";
};
export type ObjectiveQueryViewer$key = {
  readonly " $data"?: ObjectiveQueryViewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ObjectiveQueryViewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "objectives"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueDate",
  "storageKey": null
},
v5 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "image",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isGuest",
    "storageKey": null
  }
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "assigneeUser",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = [
  (v1/*: any*/),
  (v2/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "assigneeTeam",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "contributors",
  "plural": true,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "contributorsTeams",
  "plural": true,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archived",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "weight",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Cycle",
  "kind": "LinkedField",
  "name": "cycle",
  "plural": false,
  "selections": [
    (v1/*: any*/)
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Objective",
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "level",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Cycle",
      "kind": "LinkedField",
      "name": "cycle",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "KeyResult",
  "kind": "LinkedField",
  "name": "keyResults",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    (v4/*: any*/),
    (v6/*: any*/),
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metricProgress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metricType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metricCurrency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metricStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metricCurrent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metricTarget",
      "storageKey": null
    },
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "order",
      "storageKey": null
    },
    (v17/*: any*/)
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasAccess",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "archived"
    },
    {
      "kind": "RootArgument",
      "name": "assignedTo"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "before"
    },
    {
      "kind": "RootArgument",
      "name": "cycles"
    },
    {
      "kind": "RootArgument",
      "name": "display"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": 50,
      "kind": "LocalArgument",
      "name": "last"
    },
    {
      "kind": "RootArgument",
      "name": "node"
    },
    {
      "kind": "RootArgument",
      "name": "parent"
    },
    {
      "kind": "RootArgument",
      "name": "status"
    },
    {
      "kind": "RootArgument",
      "name": "title"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "bidirectional",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": {
          "count": "last",
          "cursor": "before"
        },
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./ObjectivePaginationQuery.graphql')
    }
  },
  "name": "ObjectiveQueryViewer",
  "selections": [
    {
      "alias": "objectives",
      "args": [
        {
          "kind": "Variable",
          "name": "archived",
          "variableName": "archived"
        },
        {
          "kind": "Variable",
          "name": "assignedTo",
          "variableName": "assignedTo"
        },
        {
          "kind": "Variable",
          "name": "cycles",
          "variableName": "cycles"
        },
        {
          "kind": "Variable",
          "name": "display",
          "variableName": "display"
        },
        {
          "kind": "Variable",
          "name": "node",
          "variableName": "node"
        },
        {
          "kind": "Variable",
          "name": "parent",
          "variableName": "parent"
        },
        {
          "kind": "Variable",
          "name": "status",
          "variableName": "status"
        },
        {
          "kind": "Variable",
          "name": "title",
          "variableName": "title"
        }
      ],
      "concreteType": "ObjectivesConnection",
      "kind": "LinkedField",
      "name": "__ObjectiveQuery_objectives_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ObjectivesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Objective",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/),
                (v6/*: any*/),
                (v8/*: any*/),
                (v9/*: any*/),
                (v10/*: any*/),
                (v11/*: any*/),
                (v12/*: any*/),
                (v13/*: any*/),
                (v14/*: any*/),
                (v15/*: any*/),
                (v16/*: any*/),
                (v17/*: any*/),
                (v18/*: any*/),
                (v19/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Objective",
                  "kind": "LinkedField",
                  "name": "children",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/),
                    (v2/*: any*/),
                    (v3/*: any*/),
                    (v4/*: any*/),
                    (v6/*: any*/),
                    (v8/*: any*/),
                    (v9/*: any*/),
                    (v10/*: any*/),
                    (v11/*: any*/),
                    (v12/*: any*/),
                    (v13/*: any*/),
                    (v14/*: any*/),
                    (v15/*: any*/),
                    (v16/*: any*/),
                    (v17/*: any*/),
                    (v18/*: any*/),
                    (v19/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasPreviousPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "97788db235248a9f394c8b48363d9ef1";

export default node;
